import React, { useEffect, useState } from 'react'
import { ConfirmationDialog } from 'uiComponents/popups/confirmationDialog'
import { DateFormats, formatOrInvalid } from 'utils'
import { IOrder } from 'orders/schema'
import { showErrorMessage } from 'uiComponents/message'
import { Trans, useTranslation } from 'translations'

interface UpdateDialogProps {
    accountSlug: string
    orderItemUuid: string
    order: IOrder | null
    newDate: Date
    onCancel: () => void
    onConfirm: () => void
}

function UpdateDialog({ newDate, order, onCancel, onConfirm, orderItemUuid }: UpdateDialogProps) {
    const { t } = useTranslation()
    const defaultMessage = t('orders.orders.validTo.confirmText', {
        date: formatOrInvalid(newDate, DateFormats.EXTRA_LONG_DATE),
    })
    const [text, setText] = useState<React.ReactNode>(defaultMessage)

    useEffect(() => {
        const orderItems = order?.items?.filter((x: any) => x.orderItemId === orderItemUuid)

        if (!orderItems?.length) {
            closeWithError()
        } else if (orderItems.length < 2) {
            return
        } else {
            const orderItemsBarcodes = orderItems?.map((x: any) => x?.barcode?.barcode)

            setText(
                <>
                    {defaultMessage}
                    <div>
                        <Trans
                            i18nKey="orders.orders.validTo.sameTypeNote"
                            values={{ number: orderItems.length }}
                            components={{ b: <strong /> }}
                        />
                    </div>
                    <div>
                        {orderItemsBarcodes.length > 0 && (
                            <>{t('orders.orders.validTo.barcodes', { barcodes: orderItemsBarcodes.join(', ') })}</>
                        )}
                    </div>
                </>,
            )
        }
    }, [order, orderItemUuid])

    function closeWithError() {
        showErrorMessage(t('orders.orders.validTo.loadError'), 'get_ticket_details_error')
        onCancel()
    }

    return (
        <ConfirmationDialog
            title={t('orders.orders.validTo.confirmTitle')}
            text={text}
            buttonText={t('orders.orders.validTo.confirmButton')}
            onCancel={onCancel}
            onConfirm={onConfirm}
        />
    )
}

export default UpdateDialog
